// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"474":"9008bd28","693":"372082cf"}[chunkId] + ".chunk.js";
};